export class EventsHttp {
    /**
     * Get events
     * @returns {Promise<void>}
     */
    static async getAllEvents() {
        try {
            return await window.axios.get(`events`).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Creates a event
     * @param event
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async createEvent(event) {
        try {
            return await window.axios.post(`events`, event).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Delete event
     * @param id
     * @returns {Promise<void>}
     */
    static async deleteEvent(id) {
        try {
            return await window.axios.delete(`events/${id}`).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }
}
